export const DEFAULT_LIST_COUNT = 10;

export const UNAUTHORIZED_MESSAGES = [
  "Access denied! You don't have permission for this action!",
  'Access denied! You need to be authorized to perform this action!',
  'Brak uprawnień.'
];
